<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <opq-catalogue
        code="decision-disciplinaire"
        v-model="declarationsJudiciaires.decisionDisciplinaire"
        :live="liveDeclaration(6602)"
      ></opq-catalogue>
      <template v-if="estOui(declarationsJudiciaires.decisionDisciplinaire)">
        <antecedents-judiciaires
          :antecedents="antecedents(1)"
          :sasId="sas.id"
          codeInfraction="1"
          :valids="validsDisciplinaire"
          ref="dataIterator_1"
        ></antecedents-judiciaires>
      </template>

      <v-divider class="my-3"></v-divider>

      <opq-catalogue
        code="infraction-criminelle"
        v-model="declarationsJudiciaires.infractionCriminelle"
        :live="liveDeclaration(6603)"
      ></opq-catalogue>
      <template v-if="estOui(declarationsJudiciaires.infractionCriminelle)">
        <antecedents-judiciaires
          :antecedents="antecedents(2)"
          :sasId="sas.id"
          codeInfraction="2"
          :valids="validsInfraction"
          ref="dataIterator_2"
        ></antecedents-judiciaires>
      </template>

      <v-divider class="my-3"></v-divider>

      <opq-catalogue code="infraction-5ans" v-model="declarationsJudiciaires.infraction5ans" :live="liveDeclaration(6604)"></opq-catalogue>
      <template v-if="estOui(declarationsJudiciaires.infraction5ans)">
        <antecedents-judiciaires
          :antecedents="antecedents(3)"
          :sasId="sas.id"
          codeInfraction="3"
          :valids="valids5Ans"
          ref="dataIterator_3"
        ></antecedents-judiciaires>
      </template>

      <v-divider class="my-3"></v-divider>

      <opq-catalogue
        code="infraction-responsabilite-professionnelle"
        v-model="declarationsJudiciaires.responsabiliteProfessionnelle"
        :live="liveDeclaration(6605)"
      ></opq-catalogue>
      <template v-if="estOui(declarationsJudiciaires.responsabiliteProfessionnelle)">
        <antecedents-judiciaires
          :antecedents="antecedents(4)"
          :sasId="sas.id"
          codeInfraction="4"
          :valids="validsResponsabiliteProfessionnelle"
          ref="dataIterator_4"
        ></antecedents-judiciaires>
      </template>
    </v-form>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormHybrid from "@/mixins/FormHybrid"
import AntecedentsJudiciaires from "@/components/FormParts/AntecedentsJudiciaires"
import { deleteAllOfType } from "@/plugins/services/antecedentsJudiciaires"
export default {
  mixins: [CataloguesHelper, FormHybrid],
  props: {
    sas: { type: Object, required: true }
  },
  data() {
    return {
      validsDisciplinaire: [],
      validsInfraction: [],
      valids5Ans: [],
      validsResponsabiliteProfessionnelle: []
    }
  },
  components: { AntecedentsJudiciaires },
  watch: {
    "declarationsJudiciaires.decisionDisciplinaire": function (newValue) {
      this.deleteOfType(newValue, 1)
      this.$emit("validation-changed", this.isValid)
    },
    "declarationsJudiciaires.infractionCriminelle": function (newValue) {
      this.deleteOfType(newValue, 2)
      this.$emit("validation-changed", this.isValid)
    },
    "declarationsJudiciaires.infraction5ans": function (newValue) {
      this.deleteOfType(newValue, 3)
      this.$emit("validation-changed", this.isValid)
    },
    "declarationsJudiciaires.responsabiliteProfessionnelle": function (newValue) {
      this.deleteOfType(newValue, 4)
      this.$emit("validation-changed", this.isValid)
    },
    validsInfraction() {
      this.$emit("validation-changed", this.isValid)
    },
    validsDisciplinaire() {
      this.$emit("validation-changed", this.isValid)
    },
    valids5Ans() {
      this.$emit("validation-changed", this.isValid)
    },
    validsResponsabiliteProfessionnelle() {
      this.$emit("validation-changed", this.isValid)
    }
  },
  computed: {
    declarationsJudiciaires() {
      return this.sas.declarationsJudiciaires
    },
    isValid() {
      return (
        this.valid &&
        this.validsDisciplinaire.every((x) => x) &&
        this.validsInfraction.every((x) => x) &&
        this.valids5Ans.every((x) => x) &&
        this.validsResponsabiliteProfessionnelle.every((x) => x)
      )
    }
  },

  methods: {
    liveDeclaration(cle) {
      return { endpoint: "sas-declarations-judiciaires", cle: cle, fileId: this.declarationsJudiciaires.id }
    },
    antecedents(codeInfraction) {
      let found = this.sas.antecedentsJudiciaires.find((a) => a.codeInfraction == codeInfraction)
      if (found) {
        return found.antecedents || []
      }
      return []
    },
    deleteOfType(value, codeInfraction) {
      if (this.estNon(value)) {
        deleteAllOfType(this.sas.id, codeInfraction)
        let antecedents = this.antecedents(codeInfraction)
        antecedents.splice(0, antecedents.length)
      }
    }
  }
}
</script>

<style>
</style>